import { render, staticRenderFns } from "./wine-sales-products-performance.vue?vue&type=template&id=33fdef62&scoped=true&"
import script from "./wine-sales-products-performance.vue?vue&type=script&lang=js&"
export * from "./wine-sales-products-performance.vue?vue&type=script&lang=js&"
import style0 from "./wine-sales-products-performance.vue?vue&type=style&index=0&id=33fdef62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fdef62",
  null
  
)

export default component.exports